// Configuración base compartida entre todos los ambientes
// Solo se sobreescribe en ambientes específicos si es necesario

export const LOGIN_CONFIG = {
  DOMAIN_ROUTE: '/api/timepro/v1/',
  LOGIN_ENDPOINT: 'auth/login',
  REGISTER_ENDPOINT: 'login/register',
  PASSWORD_RECOVERY_REQUEST: 'auth/password-recovery/request',
  PASSWORD_RECOVERY_RESET: 'auth/password-recovery/reset'
};

export const GESTION_CONFIG = {
  PERSONA_END_LIST: 'persona/list',
  PERSONA_END_CREATE: 'persona/',
  PERSONA_END_UPDATE: 'persona/',
  PERSONA_END_BY_RUT: 'persona/dni/',
  PERSONA_END_BY_ID: 'persona/',
  PERSONA_END_FINIQUITAR: 'persona/finiquitar',
  PERSONA_END_DOWNLOAD: 'persona/download',
  PERSONA_END_SIMPLE: 'persona/simple-search',
  PERSONA_END_SIMPLE_PAGE: 'persona/simple-search-page',
  PERSONA_END_TIPOS_EMPLEADO: 'persona/tipos-empleado',
  PERSONA_END_ME_ID: 'persona/me/id',

  CENTRO_COSTO: 'centro-costo/',
  CENTRO_COSTO_END_LIST: 'centro-costo/list',
  CENTRO_COSTO_END_BY_ID: 'centro-costo/',
  CENTRO_COSTO_END_BY_CODE: 'centro-costo/code/',
  CENTRO_COSTO_END_SEARCH: 'centro-costo/search',
  CENTRO_COSTO_END_CREATE: 'centro-costo/',
  CENTRO_COSTO_END_UPDATE: 'centro-costo/',
  CENTRO_COSTO_END_DELETE: 'centro-costo/',
  CENTRO_COSTO_CUENTAS_CARGO_ASOCIADAS: 'cuentas-cargo/asociadas',
  CENTRO_COSTO_CUENTAS_CARGO_NO_ASOCIADAS: 'cuentas-cargo/no-asociadas',
  CENTRO_COSTO_CUENTAS_CARGO_ASOCIAR: 'cuentas-cargo/asociar',

  CUENTA_CARGO_END_LIST: 'cuenta-cargo/list',
  CUENTA_CARGO_END_BY_ID: 'cuenta-cargo/',
  CUENTA_CARGO_END_CREATE: 'cuenta-cargo/',
  CUENTA_CARGO_END_UPDATE: 'cuenta-cargo/',
  CUENTA_CARGO: 'cuenta-cargo/',
  CUENTAS_CARGO_CENTRO_COSTO_ASOCIADOS: 'centros-costo/asociados',
  CUENTAS_CARGO_CENTRO_COSTO_NO_ASOCIADOS: 'centros-costo/no-asociados',
  CUENTAS_CARGO_CENTRO_COSTO_ASOCIAR: 'centros-costo/asociar',

  PROYECTO_END_LIST: 'proyecto/list',
  PROYECTO_END_PAGINADO: 'proyecto/paginado',
  PROYECTO_END_BY_ID: 'proyecto/',
  PROYECTO_END_CREATE: 'proyecto/',
  PROYECTO_END_UPDATE: 'proyecto/',
  PROYECTO_END_FIND_BY_NAME: 'proyecto/name/',
  PROYECTO_END_UPLOAD_ADJUNTO: 'proyecto/upload-adjunto',
  PROYECTO_ADJUNTOS_UPLOAD: 'proyecto/{idProyecto}/adjuntos',
  PROYECTO_ADJUNTOS_METADATOS: 'proyecto/{idProyecto}/adjuntos/metadatos',
  PROYECTO_ADJUNTO_DOWNLOAD: 'proyecto/adjunto/{adjuntoId}/download',
  /** @deprecated Usar PROYECTO_END_PRICING_ACTUAL */
  PROYECTO_END_PRICING: 'proyecto/{idPricing}/pricing',
  /** Pricing vigente del proyecto (último aprobado por ambas partes) */
  PROYECTO_END_PRICING_ACTUAL: 'proyecto/{idProyecto}/pricing/actual',
  /** Pricing específico por ID */
  PROYECTO_END_PRICING_BY_ID: 'proyecto/{idProyecto}/pricing/{idPricing}',
  /** Hitos de facturación de un pricing (SC-238) */
  PROYECTO_END_PRICING_HITOS: 'proyecto/{idProyecto}/pricing/{idPricing}/hitos',
  /** Historial paginado de pricings */
  PROYECTO_END_PRICING_HISTORIAL: 'proyecto/{idProyecto}/pricing/historial',
  PROYECTO_END_CREATE_PRICING: 'proyecto/{idProyecto}/pricing',
  PROYECTO_END_UPDATE_PRICING: 'proyecto/{idProyecto}/pricing/{idPricing}',
  /** Eliminar un pricing borrador (sin aprobaciones) — usado para rollback de importación */
  PROYECTO_END_DELETE_PRICING: 'proyecto/{idProyecto}/pricing/{idPricing}',
  /** Importar pricing desde Excel vía webhook n8n */
  PROYECTO_END_IMPORT_PRICING_EXCEL: 'proyecto/{idProyecto}/pricing/import-excel',
  /**
   * @deprecated Los hitos ahora se extraen en el import de pricing y se persisten
   * desde el dialog de vista previa. Reemplazado por PROYECTO_END_IMPORT_HITOS_FROM_PRICING.
   * Importar hitos de facturación desde un adjunto Excel existente vía webhook n8n
   */
  PROYECTO_END_IMPORT_HITOS_EXCEL: 'proyecto/{idProyecto}/pricing/{idPricing}/hitos/import-excel',
  /** Persistir hitos extraídos del import de pricing (sin re-procesar el Excel en n8n) */
  PROYECTO_END_IMPORT_HITOS_FROM_PRICING: 'proyecto/{idProyecto}/pricing/{idPricing}/hitos/import-pricing',
  /** Persistir hitos sin pricing asociado (hit_id_pricing = null) */
  PROYECTO_END_IMPORT_HITOS_SIN_PRICING: 'proyecto/{idProyecto}/hitos/import-pricing',
  /** CRUD manual de hitos sin pricing */
  PROYECTO_END_HITOS_SIN_PRICING:        'proyecto/{idProyecto}/hitos',
  PROYECTO_END_HITO_SIN_PRICING_BY_ID:   'proyecto/{idProyecto}/hitos/{idHito}',
  /** Aprobar pricing como líder de equipo */
  PROYECTO_END_PRICING_APROBAR_LIDER: 'proyecto/{idProyecto}/pricing/{idPricing}/aprobar-lider',
  /** Aprobar pricing como administración/finanzas */
  PROYECTO_END_PRICING_APROBAR_FINANZAS: 'proyecto/{idProyecto}/pricing/{idPricing}/aprobar-finanzas',
  PROYECTO_END_SIMPLE: 'proyecto/simple-search',
  PROYECTO_END_LIDERES_BY_ID_COLABORADOR: 'proyecto/lideres-asignados',
  PROYECTO_END_MIS_PROYECTOS: 'proyecto/mis-proyectos',
  PROYECTO_END_BY_CLIENTE: 'proyecto/cliente/{clienteId}/activos',
  PROYECTO_GASTOS_DIRECTOS: 'proyecto/{idProyecto}/gastos-directos',
  PROYECTO_GASTO_DIRECTO_BY_ID: 'proyecto/{idProyecto}/gastos-directos/{idGasto}',

  // Orden de Compra — un proyecto puede tener VARIAS OC, cada una vinculada a
  // hitos de facturación ya existentes. Extracción OCR de PDF vía webhook n8n
  // (no persiste), + CRUD normal.
  /** Extraer cabecera de una OC desde un PDF vía webhook n8n — no persiste nada */
  PROYECTO_END_ORDEN_COMPRA_EXTRAER_PDF: 'proyecto/{idProyecto}/orden-compra/extraer-pdf',
  /** Listado / creación de Órdenes de Compra del proyecto */
  PROYECTO_END_ORDEN_COMPRA: 'proyecto/{idProyecto}/orden-compra',
  /** Orden de Compra por ID — get/update/delete */
  PROYECTO_END_ORDEN_COMPRA_DETALLE: 'proyecto/{idProyecto}/orden-compra/{idOrdenCompra}',

  ASIGNACION: 'asignacion',
  ASIGNACION_PERSONAS_NO_ASIGNADAS: 'personas-no-asignadas/proyecto',
  ASIGNACION_PERSONAS_ASIGNADAS: 'personas-asignadas/proyecto',
  ASIGNACION_ASIGNAR_PERSONAS: 'asignar-personas/proyecto',
  ASIGNACION_LIDERES_PROYECTO_BY_PERIODO: 'lideres/proyecto',
  ASIGNACION_LIDERES_PROYECTO_TODOS: 'lideres/proyecto/todos',
  ASIGNACION_SUBCONTRATOS_BY_PROYECTO: 'subcontrato/proyecto',
  ASIGNACION_CONFIGURACION_SUBCONTRATO: 'configuracion-subcontrato',
  ASIGNACION_PORCENTAJES_MENSUALES: 'porcentajes-mensuales',
  ASIGNACION_COSTOS_MENSUALES: 'costos-mensuales',
  ASIGNACION_HORAS_MENSUALES: 'horas-mensuales',
  ASIGNACION_AGREGAR_PERSONA: 'agregar-persona',
  ASIGNACION_REMOVER_PERSONA: 'asignacion',
  ASIGNACION_PERSONAS_DISPONIBLES: 'personas-disponibles',
  ASIGNACION_PERSONAS_BUSCAR: 'personas-buscar',
  ASIGNACION_SET_LIDER: 'lider',

  SUBCONTRATO_MIS_LIQUIDACIONES: 'subcontrato/mis-liquidaciones',

  PARAM_GENERALES_END_LIST: 'parametros-generales/list',
  PARAM_GENERALES_END_BY_CODE: 'parametros-generales/codigo',
  PARAM_GENERALES_END_BY_CODE_LISTA: 'parametros-generales/codigo',
  PARAM_GENERALES_END_BY_ID: 'parametros-generales',
  PARAM_GENERALES_END_CREATE: 'parametros-generales',
  PARAM_GENERALES_END_UPDATE: 'parametros-generales',
  PARAM_GENERALES_END_TOGGLE_ACTIVO: 'parametros-generales',
  PARAM_GENERALES_END_DELETE: 'parametros-generales',

  CLIENTE_END_LIST: 'cliente/list',
  CLIENTE_END_SIMPLE: 'cliente/simple',

  // Endpoints de País
  PAIS_END_LIST: 'pais/list',
  PAIS_END_BY_PERIODO: 'pais/periodo',
  PAIS_END_BY_ID: 'pais',
  PAIS_END_CREATE: 'pais',
  PAIS_END_UPDATE: 'pais',
  PAIS_END_DELETE: 'pais',

  // Endpoints de Período de País (Calendario Laboral)
  PAIS_PERIODO_END_LIST: 'pais-periodo/list',
  PAIS_PERIODO_END_BY_ID: 'pais-periodo',
  PAIS_PERIODO_END_BY_PAIS: 'pais-periodo/pais',
  PAIS_PERIODO_END_BY_ANIO: 'pais-periodo/anio',
  PAIS_PERIODO_END_ANIOS: 'pais-periodo/anios',
  PAIS_PERIODO_END_CREATE: 'pais-periodo',
  PAIS_PERIODO_END_UPDATE: 'pais-periodo',
  PAIS_PERIODO_END_DELETE: 'pais-periodo',
  PAIS_PERIODO_END_EXISTS: 'pais-periodo/exists',
  PAIS_PERIODO_BY_PERSONA_MES: 'pais-periodo/persona/mes',

  // Endpoints de Feriados por País
  FERIADO_END_LIST: 'feriado/list',
  FERIADO_END_BY_ID: 'feriado',
  FERIADO_END_BY_PAIS: 'feriado/pais',
  FERIADO_END_BY_PAIS_ANIO: 'feriado/pais-anio',
  FERIADO_END_BY_PAIS_MES_ANIO: 'feriado/pais-mes-anio',
  FERIADO_END_BY_PAIS_RANGO: 'feriado/pais',
  FERIADO_END_BY_PERSONA_MES: 'feriado/persona/mes',
  FERIADO_END_CREATE: 'feriado',
  FERIADO_END_UPDATE: 'feriado',
  FERIADO_END_DELETE: 'feriado',
  FERIADO_END_EXISTS: 'feriado/exists',

  COMPANIE_END_LIST: 'compania/list',
  COMPANIA_END_PAGINADO:    'compania',
  COMPANIA_END_BY_ID:       'compania',
  COMPANIA_END_CREATE:      'compania',
  COMPANIA_END_UPDATE:      'compania',
  COMPANIA_END_ACTIVAR:     'compania',
  COMPANIA_END_DESACTIVAR:  'compania',
  COMPANIA_END_DELETE:      'compania',
  CARGO_END_LIST: 'cargo/list',
  CARGO_END_LIST_BY_SERVICE_LINE_ID: 'cargo/sl',
  SERVICE_END_LIST: 'service-line/list',

  USER_CHANGE_PASSWORD_ENDPOINT: 'password/change',

  // Time report
  TIME_REPORT_FILTERS_ENDPOINT: 'time-report/proyectos-completos',
  TIME_REPORT_SHEET_ENDPOINT: 'time-report',
  TIME_REPORT_PREVIOUS_SHEET_ENDPOINT: 'time-report/precarga-mes-anterior',
  TIME_REPORT_SAVE_ENDPOINT: 'time-report/guardado',
  TIME_REPORT_SUBMIT_ENDPOINT: 'time-report/enviado',
  TIME_REPORT_BULK_UPLOAD_ENDPOINT: 'time-report/carga-masiva',
  TIME_REPORT_REPORTES_PROYECTO_ENDPOINT: 'time-report/reporte-proyecto',
  TIME_REPORT_REPORTES_PROYECTO_DOWNLOAD: 'time-report/reporte-proyecto/download',
  TIME_REPORT_REPORTES_SERVICE_LINE: 'time-report/reporte-service-line',
  TIME_REPORT_REPORTES_SERVICE_LINE_DOWNLOAD: 'time-report/reporte-service-line/download',
  TIME_REPORT_REPORTES_PERSONA: 'time-report/reporte-horas-personas',
  TIME_REPORT_REPORTES_PERSONA_DOWNLOAD: 'time-report/reporte-horas-personas/download',
  TIME_REPORT_REPORTES_CARGABILIDAD: 'time-report/reporte-cargabilidad',
  TIME_REPORT_REPORTES_CARGABILIDAD_DOWNLOAD: 'time-report/reporte-cargabilidad/download',
  TIME_REPORT_REPORTES_ESTADO_CARGA: 'time-report/reporte-estado-carga',
  TIME_REPORT_REPORTES_ESTADO_CARGA_DOWNLOAD: 'time-report/reporte-estado-carga/download',
  TIME_REPORT_REPORTES_VACACIONES: 'solicitud-vacaciones/reporte',

  // Mi Portal - Solicitud de Vacaciones
  SOLICITUD_VACACIONES_LIST: 'solicitud-vacaciones/list',
  SOLICITUD_VACACIONES_BY_ID: 'solicitud-vacaciones',
  SOLICITUD_VACACIONES_CREATE: 'solicitud-vacaciones',
  SOLICITUD_VACACIONES_UPDATE: 'solicitud-vacaciones',
  SOLICITUD_VACACIONES_DELETE: 'solicitud-vacaciones',
  SOLICITUD_VACACIONES_ESTADOS: 'solicitud-vacaciones/estados',
  SOLICITUD_VACACIONES_DIAS_DISPONIBLES: 'solicitud-vacaciones/dias-disponibles',
  SOLICITUD_VACACIONES_CALCULAR_DIAS: 'solicitud-vacaciones/calcular-dias-habiles',
  SOLICITUD_VACACIONES_RESUMEN: 'solicitud-vacaciones/resumen',
  SOLICITUD_VACACIONES_PERSONA_DIAS: 'solicitud-vacaciones/persona-dias/',
  SOLICITUD_VACACIONES_MOVIMIENTOS: 'solicitud-vacaciones/movimientos',

  // Proyecto - Mis Aprobaciones
  // IMPLEMENTADO: Endpoint para listar solicitudes según rol (RRHH ve todas, Líderes ven asignadas + sin líder)
  APROBACIONES_LIST: 'solicitud-vacaciones/aprobaciones/list',
  // IMPLEMENTADO: Endpoint para obtener estadísticas de aprobaciones según rol
  APROBACIONES_ESTADISTICAS: 'solicitud-vacaciones/aprobaciones/estadisticas',
  // TODO Backend: Implementar endpoints específicos con lógica de doble aprobación (Líder + RRHH)
  APROBACIONES_APROBAR: 'solicitud-vacaciones/aprobaciones/aprobar', // NO IMPLEMENTADO - usar SOLICITUD_VACACIONES_UPDATE con estadoId=2
  APROBACIONES_RECHAZAR: 'solicitud-vacaciones/aprobaciones/rechazar', // NO IMPLEMENTADO - usar SOLICITUD_VACACIONES_UPDATE con estadoId=3

  // Finanzas - Liquidaciones de Sueldo
  LIQUIDACION_SUELDO_END_LIST: 'liquidacion-sueldo/list',
  LIQUIDACION_SUELDO_END_BY_ID: 'liquidacion-sueldo/{id}',
  LIQUIDACION_SUELDO_END_CREATE: 'liquidacion-sueldo/',
  LIQUIDACION_SUELDO_END_UPDATE: 'liquidacion-sueldo/{id}',
  LIQUIDACION_SUELDO_RECIBOS_UPLOAD: 'liquidacion-sueldo/{idLiquidacion}/recibos',
  LIQUIDACION_SUELDO_RECIBOS_METADATOS: 'liquidacion-sueldo/{idLiquidacion}/recibos/metadatos',
  LIQUIDACION_SUELDO_RECIBO_DOWNLOAD: 'liquidacion-sueldo/recibo/{reciboId}/download',
  // Endpoint para carga masiva sin idLiquidacion
  LIQUIDACION_SUELDO_ADJUNTO_LOTE: 'liquidaciones/adjunto',
  // Endpoint para descargar adjunto por UUID
  LIQUIDACION_SUELDO_ADJUNTO_DOWNLOAD: 'liquidaciones/adjunto/{uuid}/download',
  // Endpoint para reemplazar PDF de liquidación
  LIQUIDACION_SUELDO_ADJUNTO_REPLACE: 'liquidaciones/adjunto/{uuid}',
  // Endpoint para validar liquidación (RRHH)
  LIQUIDACION_SUELDO_ADJUNTO_VALIDAR: 'liquidaciones/adjunto/{uuid}/validar',
  // Endpoint para listar liquidaciones del usuario autenticado
  LIQUIDACION_SUELDO_MIS_LIQUIDACIONES: 'liquidaciones/mis-liquidaciones',
  // Endpoint para listar todas las liquidaciones con paginación y filtros (admin)
  LIQUIDACION_SUELDO_ADJUNTO_LIST: 'liquidaciones/list',
  // Endpoint para listar liquidaciones agrupadas por país-mes-año-lote (admin)
  LIQUIDACION_SUELDO_ADJUNTO_LIST_AGRUPADAS: 'liquidaciones/list-agrupadas'
  ,
  // Endpoint para borrar lógicamente liquidaciones por filtros (admin)
  LIQUIDACION_SUELDO_ADJUNTO_BORRAR: 'liquidaciones/adjunto/borrar',

  // Búsqueda de Reclutamiento
  BUSQUEDA_RECLUTAMIENTO_LIST: 'busqueda-reclutamiento',
  BUSQUEDA_RECLUTAMIENTO_MIS_BUSQUEDAS: 'busqueda-reclutamiento/mis-busquedas',
  BUSQUEDA_RECLUTAMIENTO_BY_ID: 'busqueda-reclutamiento',
  BUSQUEDA_RECLUTAMIENTO_CREATE: 'busqueda-reclutamiento',
  BUSQUEDA_RECLUTAMIENTO_UPDATE: 'busqueda-reclutamiento',
  BUSQUEDA_RECLUTAMIENTO_CERRAR: 'busqueda-reclutamiento/{id}/cerrar',
  BUSQUEDA_RECLUTAMIENTO_DOWNLOAD: 'busqueda-reclutamiento/download',

  // Candidatos
  CANDIDATOS_LIST: 'candidatos',
  CANDIDATOS_BY_ID: 'candidatos',
  CANDIDATOS_CREATE: 'candidatos',
  CANDIDATOS_UPDATE: 'candidatos',
  CANDIDATOS_CV: 'candidatos',

  // Período Activo Global
  PERIODO_ACTIVO_ENDPOINT: 'periodo-activo',

  // Finanzas - Facturación Multi-país
  FACTURA_END_LIST:         'factura',
  FACTURA_END_SEARCH:       'factura/search',
  FACTURA_END_CREATE:       'factura',
  FACTURA_END_UPDATE:       'factura/',
  FACTURA_END_BY_ID:        'factura/',
  FACTURA_END_ESTADO:       'factura/',
  FACTURA_END_MARCAR_PAGADA:'factura/',
  FACTURA_END_DOWNLOAD:     'factura/download',
  // SC-262 — Registro de Factura: Hitos, Órdenes de Compra y HES
  /** OC candidatas para cubrir un hito (todas las del proyecto del hito, con saldo) */
  FACTURA_END_OC_CANDIDATAS: 'factura/distribucion/hitos/{idHito}/ordenes-compra-candidatas',
  /** Hitos vigentes sin ninguna OC asociada en su proyecto */
  FACTURA_END_HITOS_SIN_OC: 'factura/distribucion/hitos-sin-oc',
  /** Reporte "qué facturar": hitos pendientes, con advertencia de HES no bloqueante */
  FACTURA_END_QUE_FACTURAR: 'factura/distribucion/que-facturar',
  // SC-240 — Vista de control de facturación por hitos
  /** Vista paginada de control de facturación (todos los hitos de proyectos activos) */
  FACTURA_END_CONTROL_FACTURACION: 'factura/distribucion/control-facturacion',
  /** Totales por proyecto (saldo pendiente de facturar + total acumulado) */
  FACTURA_END_CONTROL_FACTURACION_RESUMEN: 'factura/distribucion/control-facturacion/resumen-por-proyecto',
};

// Configuración del módulo de administración
export const ADMIN_CONFIG = {
  DOMAIN_ROUTE: 'admin/',
  PERSONAS_ROUTE: 'personas',
  PERFILES_ROUTE: 'perfiles',
  ROLES_ROUTE: 'roles',
  TIME_REPORT_STATUS_ROUTE: 'time-reports/status',
  API_KEY_ROUTE: 'api-key',
  // Compañías — los endpoints reales viven en /v1/compania (GESTION_CONFIG)
  COMPANIA_ROUTE: 'compania',
  // Menú dinámico
  MENU_MY_MENU: 'menu/my-menu',
  MENU_ADMIN_ITEMS: 'menu/admin/items',
  MENU_ADMIN_ROLE_ACCESS: 'menu/admin/role-access',
};
